import { Field } from '@app-model/form';
import { OptionType } from '@app-model/form';

export class ProductFormResponse {
  constructor(
    public productForm: Field[] = [],
    public financeType: OptionType = new OptionType(),
    public isAfterSale: OptionType = new OptionType(),
    public vehicleCondition: OptionType = new OptionType(),
  ) {
  }
}
